module.exports = __webpack_public_path__ + "static/headphones-banner-parallax-section-code-604aa7eb67625216ae0289b7d3858938.png";